import { useApiClient } from "@myplant-io/utils/api";
import { useMutation, useQueryClient } from "react-query";

import { Conversation } from "../types";

type CopyConversationInput = {
  conversationId: string;
  upToMessageId: string;
};

export function useConversationCopy() {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<Conversation, unknown, CopyConversationInput>(
    ({ conversationId, upToMessageId }) =>
      client.fetch(
        `/api/history/conversation/${conversationId}/copy?up_to_message_id=${upToMessageId}`,
        { method: "POST" },
      ),
    {
      onSettled: () => {
        queryClient.invalidateQueries("conversation");
      },
    },
  );
}
